import { ModelType, eventType } from "../../../../../../API";

import { CHART_CONTAINER_HEIGHT } from "../../../system-health/common/values";
import CircularLoading from "../../../../../../common/components/progress/CircularLoading";
import { FeedbackInsightsChartProps } from "../../models";
import SimplePaperWrapper from "../../../../../../common/components/item/SimplePaperWrapper";
import StatisticsNoDataView from "../../../system-performance/components/StatisticsNoDataView";
import StyledChart from "../../../../../../common/components/apexchart/StyledChart";
import Typography from "@mui/material/Typography";
import { useFalsePositiveEventsChart } from "../../hooks/useFalsePositiveEventsChart";

const FalsePositiveEventsContainer = ({
  selectedLocations,
  activeTimePeriod,
}: FeedbackInsightsChartProps) => {
  const { series, options, loading, refetching, showNoData } =
    useFalsePositiveEventsChart(
      eventType.falsePositiveEvents,
      [
        ModelType.fire,
        ModelType.smoke,
        ModelType.gasleak,
        ModelType.liquidleak,
        ModelType.hardhat,
      ],
      selectedLocations,
      activeTimePeriod
    );

  return (
    <SimplePaperWrapper
      sx={{
        padding: "1.5em",
        height: CHART_CONTAINER_HEIGHT,
        borderRadius: "8px",
      }}
    >
      <Typography mb="1em" variant="h5">
        False positive events
      </Typography>
      {(loading || refetching) && <CircularLoading />}
      {!loading && !showNoData && (
        <StyledChart
          options={options}
          series={series}
          height={300}
          type="bar"
        />
      )}
      {showNoData && <StatisticsNoDataView />}
    </SimplePaperWrapper>
  );
};

export default FalsePositiveEventsContainer;
